define(
    'viewmodels/secured/explorer/details/tabs/actions/actionsUploadRequest/actionsUploadRequest',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModelNotification",
        "services/service.documents",
        "i19n!i19n/strings",
        "plugins/router",
        "providers/dataprovider",
    ],
    function (ctx, ViewModelNotification, documentService, i19n, router, dataProvider) {
        var editorMessage = null;
        var $expiry = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            subject: ko.observable(''),
            message: ko.observable(''),
            documentsWillbeUploadedText: ko.observable(''),
            items: ko.observableArray([]),
            selected: ko.observableArray([]),
            isPopupOpen: false,
            dataSourceEmail: null,
            canUploadRequest: ko.observable(false),
            isVisible: ko.observable(false),
            isSendNotification: ko.observable(true)
        });

        vm.activate = function () {
            if (!ctx.current.folder || !ctx.current.folder.folderId) {
                vm.isVisible(false);
                
                if (sessionStorage.__url) {
                    window.location.href = sessionStorage.__url;
                } else {
                    router.navigate("explorer");
                }
                //router.navigate("explorer");

                location.reload();

                return false;
            }

            vm.isVisible(true);

            var documents = sessionStorage.getItem("share");
            var jDocuments = JSON.parse(documents);

            //console.warn(ctx.current.folder().parent());
            vm.documentsWillbeUploadedText("Documents will be uploaded to folder: " + ctx.current.library.name + '/' + (ctx.current.folder.listId ? ctx.current.library.list.active.selectedRow().label : ctx.current.folder.name()));

            vm.subject(i19n.to.pleaseuploaddocuments);
            vm.message('');

            if (editorMessage)
                editorMessage.value('');            

     
            if (vm.dataSourceEmail == null) {
                vm.dataSourceEmail = new kendo.data.DataSource({
                    data: vm.selected(),
                    change: function () {
                        vm.canUploadRequest(this._data.length > 0);
                    }
                });
            } else {
                vm.dataSourceEmail.read();

                addDefaultUser();
            }

            

            if ($expiry != null)
                $expiry.val(0);
        };
        vm.attached = function () {
            vm.notifications([]);                       

            vm.dataSourceEmail.bind("change", function () {
                var html = kendo.render(kendo.template($("#listTemplate").html()), this.view());

                $("#listview").html(html);
                $("button[data-name]").unbind("click");
                $("button[data-name]").bind("click", function (e) {
                    if (e.currentTarget.attributes.length >= 1) {
                        if (e.currentTarget.attributes[0].name === "data-name") {
                            e.preventDefault();

                            var name = e.currentTarget.attributes[0].value;
                            var raw = vm.dataSourceEmail.data();

                            for (var i = raw.length - 1; i >= 0; i--) {
                                if (raw[i].title === name) {
                                    vm.dataSourceEmail.remove(raw[i]);
                                }
                            }
                        }
                    }
                });
            });

            vm.dataSourceEmail.read();

            $("#main-search-request").kendoAutoComplete({
                minLength: 3,
                dataTextField: "title",
                placeholder: i19n.to.emailaddress,
                template: kendo.template($("#search-result-template").html()),
                dataSource: new kendo.data.DataSource({
                    data: vm.items()
                }),
                dataBound: function (e) {
                },
                close: function (e) {
                },
                open: function (e) {
                },
                select: function (e) {
                    var email = e.item.children("div").data("email");
                    var itemid = e.item.children("div").data("itemid");
                    var title = e.item.children("div").data("title");
                    var itemtype = e.item.children("div").data("itemtype");
                    var itemIcon = e.item.children("div").data("itemicon");

                    e.preventDefault();
                    e.sender.value("");

                    if (title != "") {
                        var titleList = new Array();

                        for (var i = 0; i < vm.dataSourceEmail._data.length; i++) {
                            titleList.push(vm.dataSourceEmail._data[i].title.trim());
                        }

                        var toAdd = !_.contains(titleList, title.trim());                        

                        if (toAdd) {
                            var itm = {
                                email: email,
                                itemid: itemid,
                                title: title.trim(),
                                itemtype: itemtype,
                                itemIcon: itemIcon
                            };

                            vm.dataSourceEmail.add(itm);
                        }
                    }
                }
            });//.parent().removeClass();

            $("#main-search-request").bind("click", function () {
                //$(this).parent().removeClass();
            });
            $("#main-search-request").bind("keypress", function (e) {
                if (e.which == 13) {
                    e.preventDefault();

                    var email = new String($("#main-search-request").val());
        
                    addEmail(email);
                }
            });
            $("#main-search-request").bind("blur", function (e) {
                var email = new String($("#main-search-request").val());

                addEmail(email);
            });

            // create Editor from textarea HTML element with default set of tools
            editorMessage = $("#editor-message-request").kendoEditor({
                tools: [
                    "viewHtml",
                    "formatting",
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "justifyLeft",
                    "justifyCenter",
                    "justifyRight",
                    "justifyFull",
                    "insertUnorderedList",
                    "insertOrderedList",
                    "indent",
                    "outdent",
                    "createLink",
                    "unlink",
                    "insertImage",
                    "insertFile",
                    "subscript",
                    "superscript",
                    "createTable",
                    "addRowAbove",
                    "addRowBelow",
                    "addColumnLeft",
                    "addColumnRight",
                    "deleteRow",
                    "deleteColumn",
                    "cleanFormatting",
                    "fontName",
                    "fontSize",
                    "foreColor",
                    "backColor"
                ],
                resizable: {
                    content: true,
                    toolbar: true
                },
                change: function (e) {
                    vm.message(this.value());

                    if (this._format) {
                        setDefaultFontEditor();
                        this._format = null;
                        vm.message(this.value());
                    }

                    if (vm.message() == "") {
                        this._format = true;
                    }                                        
                }
            }).data("kendoEditor");

            if (vm.message() == "") {
                setDefaultFontEditor();
            }

            $expiry = $("#selectExpiry");

            addDefaultUser();

            function addEmail(emails) {
                var ss = [];

                if (emails) {
                    emails = emails.replace(',', ';') + ';';
                    ss = emails.split(';');

                    _.map(ss, function (itm) {
                        _addEmail(itm);
                    });
                }

                function _addEmail(email) {
                    if (email.indexOf("@") == -1)
                        return;

                    if (email.indexOf(".", email.indexOf("@")) == -1)
                        return;

                    if (email != "") {
                        var titleList = new Array();

                        for (var i = 0; i < vm.dataSourceEmail._data.length; i++) {
                            titleList.push(vm.dataSourceEmail._data[i].title.trim());
                        }

                        var toAdd = !_.contains(titleList, email.trim());

                        if (toAdd) {
                            var itm = {
                                email: email,
                                itemid: '',
                                title: email.trim(),
                                itemtype: 'email',
                                itemIcon: 'fa fa-envelope'
                            };

                            vm.dataSourceEmail.add(itm);

                            $("#main-search-request").val('');
                        }
                    }
                }
            }            
            function setDefaultFontEditor() {
                var range = editorMessage.getRange();
                range.setStart(editorMessage.body, 0);
                range.setEnd(editorMessage.body, editorMessage.body.childNodes.length);
                editorMessage.selectRange(range);
                editorMessage.exec("fontName", { value: "Arial" });
                editorMessage.exec("fontSize", { value: "12pt" });
                range.collapse(true);
                editorMessage.selectRange(range);
            }
        };
  
        vm.close = function () {
            //$("#listview").empty();
            $("#selectExpiry option[value='0']").attr("selected", true);

            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        vm.send = ko.asyncCommand({
            canExecute: function (isExecuting) {                
                return !isExecuting && vm.canUploadRequest() && vm.subject().length > 0;
            },
            execute: function (complete) {
                //console.warn(vm.isSendNotification());
                //complete();

                //return;

                if (vm.dataSourceEmail._data.length == 0) {
                    vm.notify('error', i19n.to.emailisrequired);

                    complete();

                    return;
                }               
                if (vm.subject() == '') {
                    vm.notify('error', i19n.to.subjectisrequired);

                    complete();

                    return;
                }              

                var siteUrl = window.location.href.toString(); siteUrl = siteUrl.replace("#actionsUploadRequest", "#upload/id=");
                var sharewith = _.map(vm.dataSourceEmail._data, function (itm) {
                    return {
                        itemType: itm.itemtype,
                        itemId: itm.itemid,
                        title: itm.title,
                        emailAddress: itm.email
                    };
                });                

                var data = {
                    folderId: ctx.current.folder.folderId,
                    subject: vm.subject(),
                    message: vm.message(),
                    siteUrl: siteUrl,
                    shareexpiryhours: $("#selectExpiry").val(),
                    sharedwith: sharewith,
                    sendnotification: vm.isSendNotification()
                };

                dataProvider.folders
                .addFolderShare(data)
                .done(function (result) {
                    
                    //$("#listview").empty();                    
                    //$("#selectExpiry option[value='0']").attr("selected", true);

                    //vm.subject('');
                    //vm.message('');

                    if (sessionStorage.__url) {
                        window.location.href = sessionStorage.__url;
                    } else {
                        router.navigate("explorer");
                    }
                    //router.navigate("explorer");
                })
                .fail(function (e) {
                    console.error(e);
                })
                .always(function () {
                    complete();
                });
            }
        });

        return vm;

        function addDefaultUser() {
            if (!vm.dataSourceEmail || vm.dataSourceEmail._data.length > 0)
                return;

            var itm = {
                email: vm.session.user().emailAddress(),
                itemid: vm.session.user().userId(),
                title: vm.session.user().displayName(),
                itemtype: "person",
                itemIcon: "fa fa-user"
            };

            vm.dataSourceEmail.add(itm);
        }
    });
